import { render, staticRenderFns } from "./mailSettingEdit.vue?vue&type=template&id=38f73b12&scoped=true&"
import script from "./mailSettingEdit.vue?vue&type=script&lang=js&"
export * from "./mailSettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingEdit.vue?vue&type=style&index=0&id=38f73b12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f73b12",
  null
  
)

export default component.exports